import React from 'react'

import { Text } from '@wartek-id/text-v1'

import type { FC, HTMLProps, ReactElement } from 'react'

interface CompetencyIndicatorGroupProps extends HTMLProps<HTMLDivElement> {
  name: string
  icon: ReactElement
}

const CompetencyIndicatorGroup: FC<CompetencyIndicatorGroupProps> = ({
  children,
  name,
  icon,
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center gap-2 mb-2">
        {icon}
        <Text variant="heading-md" className="capitalize">
          {name}
        </Text>
      </div>
      {children}
    </div>
  )
}

export default CompetencyIndicatorGroup
